export default class BookingQuestionManager {
    constructor() {
        this.eventDelegation();
    }

    eventDelegation() {
        const answerSelect = document.querySelector('[name="idAnswer"]');
        const sendButton = document.querySelector('[name="send"]');
        answerSelect?.addEventListener('change', () => {
            sendButton?.classList.remove('disabled');
        }, { once: true });
    }
}
